export const FontWeightRegular = 'normal';
export const FontWeightMedium = '500';
export const FontWeightBold = 'bold';
